'use client'

import { AreaItem } from '@/types/cms/AreaItem'
import Sidebar from '@/components/Sidebar/Sidebar/Sidebar'
import { MenuSidebarDefaultTree } from '@/elements/widgets/Menu/Sidebar/MenuSidebarDefaultTree'

const uniquerItems = (
  items: any[],
  prefix: string,
  contentStreamItems: any[] | undefined,
  isRoot: boolean = false,
): any => {
  return items.map((item, idx) => ({
    ...item,
    isRoot: prefix === 'main' || isRoot,
    level: prefix,
    id: `${prefix}-${idx}`,
    children: item.children
      ? uniquerItems(item.children, `${prefix}-${idx}`, contentStreamItems, prefix === 'main')
      : undefined,
    image:
      item?.fields?.content && contentStreamItems
        ? contentStreamItems.find((content) => content.id === item?.fields?.content)?.model?.image
        : undefined,
  }))
}

const MenuSidebarDefault = ({ item }: { item: AreaItem }) => {
  if (!item?.model?.menu || !Array.isArray(item.model.menu) || item.model.menu.length === 0) {
    console.warn('MenuSidebarDefault: No menu found in item model', item)
    return null
  }

  return (
    <Sidebar id="main">
      <MenuSidebarDefaultTree sidebarId="main" items={uniquerItems(item.model.menu || [], 'main', item.items)} />
    </Sidebar>
  )
}

export default MenuSidebarDefault
